"use client";

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const { pathname } = useLocation();

  const [isToggleNavbar, setToggleNavbar] = useState(true);

  const handleToggleNavbar = () => {
    setToggleNavbar(!isToggleNavbar);
  };

  React.useEffect(() => {
    const elementId = document.getElementById("navbar");
    if (!elementId) return;

    const onScroll = () => {
      if (window.scrollY > 170) {
        elementId.classList.add("sticky");
      } else {
        elementId.classList.remove("sticky");
      }
    };

    document.addEventListener("scroll", onScroll);

    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div id="navbar" className="fp-navbar-area transition">
      <div className="container">
        <nav className="navbar navbar-expand-lg bg-white rounded-pill shadow-sm px-3 py-2 align-items-center">
          <Link className="navbar-brand me-3" to="/">
            <img
              src="/images/ynetltd.png"
              alt="logo"
              width={142}
              height={38}
            />
            <img
              src="/images/ynetlogo.png"
              className="d-none"
              alt="logo"
              width={142}
              height={38}
            />
          </Link>

          <button
            className="navbar-toggler"
            onClick={handleToggleNavbar}
            aria-label="Toggle navigation"
          >
            <span className="burger-menu">
              <span className="top-bar"></span>
              <span className="middle-bar"></span>
              <span className="bottom-bar"></span>
            </span>
          </button>

          <div
            className={`collapse navbar-collapse ${
              isToggleNavbar ? "" : "show"
            }`}
          >
            <ul className="navbar-nav mx-auto align-items-center">
              <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link ${pathname === "/" ? "active" : ""}`}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/services/"
                  className={`nav-link ${
                    pathname === "/services/" ? "active" : ""
                  }`}
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/solutions/"
                  className={`nav-link ${
                    pathname === "/solutions/" ? "active" : ""
                  }`}
                >
                  Solutions
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/about/"
                  className={`nav-link ${
                    pathname === "/about/" ? "active" : ""
                  }`}
                >
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact/"
                  className={`nav-link ${
                    pathname === "/contact/" ? "active" : ""
                  }`}
                >
                  Contact
                </Link>
              </li>
            </ul>

            <div className="ms-auto d-flex align-items-center">
              <Link to="/contact/" className="btn btn-demo rounded-pill px-4 py-2">
                Work With Us
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
